import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import moment from 'moment';

type ZoneName = 'L' | 'Z';

function resolveZoneName(timeZone: unknown): ZoneName {
  if (typeof timeZone === 'string' && (timeZone === 'L' || timeZone === 'Z')) {
    return timeZone;
  }
  if (timeZone && typeof timeZone === 'object' && 'name' in timeZone) {
    const name = (timeZone as { name?: string }).name;
    if (name === 'L' || name === 'Z') {
      return name;
    }
  }
  return 'Z';
}

export function arrivalAfterDepartureValidator(): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const departureTimeValue = formGroup.get('departureDateTime')?.value;
    const arrivalTimeValue = formGroup.get('arrivalDateTime')?.value;
    const departureTz = resolveZoneName(
      formGroup.get('timeZoneDeparture')?.value
    );
    const arrivalTz = resolveZoneName(formGroup.get('timeZoneArrival')?.value);
    const departureAirportZone = formGroup.get('fromAirport')?.value?.timeZone;
    const arrivalAirportZone = formGroup.get('toAirport')?.value?.timeZone;

    if (
      !departureTimeValue ||
      !arrivalTimeValue ||
      !departureAirportZone ||
      !arrivalAirportZone
    ) {
      return null;
    }

    const formatTimeString = (dateTime: any) => {
      const m = moment(dateTime);
      return m.format('YYYY-MM-DDTHH:mm:ss');
    };
    const getUtcTime = (
      timeStr: string,
      timeZone: ZoneName,
      airportZone: string
    ) => {
      if (timeZone === 'L') {
        return moment.tz(timeStr, airportZone).utc();
      } else {
        return moment.utc(timeStr);
      }
    };
    const departureTimeStr = formatTimeString(departureTimeValue);
    const arrivalTimeStr = formatTimeString(arrivalTimeValue);

    const departureUtc = getUtcTime(
      departureTimeStr,
      departureTz,
      departureAirportZone
    );
    const arrivalUtc = getUtcTime(
      arrivalTimeStr,
      arrivalTz,
      arrivalAirportZone
    );
    return arrivalUtc.isAfter(departureUtc)
      ? null
      : { arrivalAfterDeparture: true };
  };
}
